/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconOverline = createReactComponent("outline", "overline", "IconOverline", [["path", { "d": "M7 9v5a5 5 0 0 0 10 0v-5", "key": "svg-0" }], ["path", { "d": "M5 5h14", "key": "svg-1" }]]);

export { IconOverline as default };
//# sourceMappingURL=IconOverline.mjs.map
